import { toIsoDate } from "@acto/web-common/dates";
import type { useTranslations } from "@acto/web-common/locales";
import type { HideDuration } from "@acto/taskpane/core/domain/ProductExclusion";
import { formatNumericDate } from "@acto/taskpane/field-sales-2/utils/format";

type Translate = ReturnType<typeof useTranslations>;

export function hideDurationLabel(duration: HideDuration, t: Translate, locale: string): string {
  return duration.kind === "forever"
    ? t("durationForever")
    : t("durationUntil", { date: formatNumericDate(toIsoDate(duration.lastDay), locale) });
}
